import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetAML(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
      lang: "EN"
    },
    url: `${BASE_URL}/api/aml`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}


export interface materialText{
  clientId: number;
  materialNum: string;
  lang: string;
  materialNumShort: string | null;
  description: string | null;
  guid: string;
}
export async function GetAllMaterialText() {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      lang: "EN"
    },
    url: `${BASE_URL}/api/material/all`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
